<template>
<input class="datepick" v-model="value" type="text" :placeholder="placeholder">
</template>

<script>
jQuery.extend(jQuery.fn.pickadate.defaults, {
    monthsFull: [ '1月', '2月', '3月', '4月', '5月', '6月', '7月', '8月', '9月', '10月', '11月', '12月' ],
    monthsShort: [ '1月', '2月', '3月', '4月', '5月', '6月', '7月', '8月', '9月', '10月', '11月', '12月' ],
    weekdaysFull: [ '日曜' , '月曜', '火曜', '水曜', '木曜', '金曜', '土曜'],
    weekdaysShort: [ '日曜' ,  '月曜', '火曜', '水曜', '木曜', '金曜', '土曜'],
    today: '今日',
    clear: 'クリア',
    close: '閉じる',
    format: 'yyyy/mm/dd'
});

export default {
    props: {
        value: {
            required: true,
        },
        from: {
            required: false,
            type: Number,
        },
        placeholder: {
            required: false,
            type: String
        }
    },
    watch: {
        value: function() {
            var diff = moment(this.value).diff(moment(), 'days');
            // 設定値が選択可能な範囲内の場合だけ反映
            if (diff >= this.from) {
                $(this.$el).pickadate('picker').set('select', this.value, {format: 'yyyy-mm-dd'});
            }
        }
    },
    mounted: function() {
        var self = this;
        $(this.$el).pickadate({
            min: this.from === 0 ? moment().toDate() : this.from,
            max: false,
            onSet: function() {
                self.$emit('input', this.get());
                self.$emit('change', this.get());
            }
        });
    }
};
</script>
